export enum HeaderType {
  Basic = 'Basic',
  Funnels = 'Funnels',
  Login = 'Login',
  MemberPortal = 'MemberPortal',
  Pci = 'Pci',
  SecondaryBrand = 'SecondaryBrand',
  Countdown = 'Countdown',
  MemberPortalFinsights = 'MemberPortalFinsights',
  Header1087 = 'Header1087',
}
